import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from '../../ui/Modal';
import { ContactForm } from '../../../pages/Contact/ContactForm';
import { sendContactForm } from '../../../services/api';
import { useLanguage } from '../../../contexts/LanguageContext';

const initialFormState = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
};

export const ServiceContactModal = ({ isOpen, onClose, serviceTitle }) => {
    const { t } = useLanguage();
    const [form, setForm] = useState(initialFormState);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    // Reset form and set initial subject when modal opens with a new service
    useEffect(() => {
        if (isOpen && serviceTitle) {
            setForm({
                ...initialFormState,
                subject: serviceTitle,
                message: `${serviceTitle} hakkında bilgi almak istiyorum.`
            });
            setSubmitStatus(null);
        }
    }, [isOpen, serviceTitle]);

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    }, []);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            // Send contact form to backend API
            await sendContactForm(form);
            setSubmitStatus('success');
            // Close modal after short delay on success or keep it open to show success message?
            // Usually showing success message is better.
            setTimeout(() => {
                onClose();
                setForm(initialFormState);
            }, 2000);
        } catch {
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    }, [form, onClose]);

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            title={t('contact.formTitle')}
            size="lg"
        >
            <div className="p-1">
                {submitStatus === 'success' ? (
                    <div className="text-center py-12">
                        <h3 className="text-2xl font-bold text-green-600 mb-4">{t('contactForm.success')}</h3>
                        <p className="text-gray-600">{t('contactForm.successMessage')}</p>
                    </div>
                ) : (
                    <ContactForm
                        form={form}
                        onChange={handleChange}
                        onSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                    />
                )}
            </div>
        </Modal>
    );
};
